import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {Chunker, ChunkerFilter} from '../chunker';
import {UIFormEngineComponentMetadata} from './form';
import {UIHelperTable2excel} from './helper/table2excel';

(window as any);

@Component({
	selector: 'ui-table',
	templateUrl: 'table.html'
})
export class UITableComponent implements OnChanges {
	@Input() chunker: Chunker;
	@Input() headers: UITableComponentHeader[] = [];
	@Output() chunked = new EventEmitter();
	@Input() filters = false;
	@Input() options: UITableComponentOptions;

	public data = [];
	public isFiltered = false;
	public filtersValues = {};
	public sorting = null;
	@Input() paginationSize = 10;
	public expanded = false;
	public expandedWidth = '';
	public chunkedSize = 0;

	public constructor() {
	}

	public removeFilters() {
		for (const h in this.headers) {
			if (this.headers[h].filterValue) {
				this.headers[h].filterValue = null;
			}
		}
		this.loadData();
		this.resetPagination();
	}

	public hasFiltersOn() {
		for (const h of this.headers) {
			if (h.filterValue) {
				return true;
			}
		}
		return false;
	}

	onRefresh() {
		if (this.options.onRefreshFunction) {
			this.options.onRefreshFunction.call(this.options.onRefreshContext);
		}

	}

	expand() {
		this.expanded = !this.expanded;
		this.expandedWidth = this.expanded
			? '' + (window.innerWidth - 200) + 'px'
			: '';
	}

	ngOnChanges(sc) {
		// console.log('ui-table change', sc);
		this.loadData();
	}

	downloadAsExcel() {
		const helper = new UIHelperTable2excel();
		const headers = this.options?.downloadAsExcelHeaders ? this.options.downloadAsExcelHeaders.call(this) : this.headers;

		helper.exportAsExcel(headers, this.chunker.getOriginalData(), this.options?.downloadAsExcelRowFormatter);
	}

	applyFiltersTimeout = null;

	applyFilters(changedHeader: string[]) {
		// console.log('applyfilters', changedHeader);
		clearTimeout(this.applyFiltersTimeout);
		this.applyFiltersTimeout = setTimeout(() => {
			this.resetPagination();
			this.loadData();
			clearTimeout(this.applyFiltersTimeout);
		}, 100);
	}

	// sorting && (!sorting.direction || sorting.by.id != h.id?'asc':sorting.direction=='dsc'?'asc':'dsc')
	sortBy(header: ChunkerFilter) {
		if (header.sortable) {
			const sameThanLastTime = this.sorting && this.sorting.by && this.sorting.by.id === header.id;

			let direction = 'asc';
			if (sameThanLastTime) {
				direction = this.sorting.direction === 'asc' ? 'dsc' : 'asc';
			}
			console.log('sorting ', {direction, sameThanLastTime});

			this.sorting = {by: header, direction};

			this.loadData();
		}
	}

	onPaginationSizeChange(newVal) {
		this.chunker.pagination.currentPage = 1;
		this.paginationSize = newVal;
		this.loadData();
	}

	public resetPagination() {
		this.chunker.pagination.currentPage = 1;
	}

	public loadData() {
		this.chunker.pagination.size = this.paginationSize;

		this.chunker.applyFilters(this.headers);
		if (this.sorting && this.sorting.by) {
			this.chunker.applySort(this.sorting.by, this.sorting.direction);
		}
		this.data = this.chunker.extractData();

		this.chunkedSize = this.data.length;

		this.chunked.emit(this.data);
		this.isFiltered = this.chunker.size !== this.data.length;
	}

	previous() {
		this.chunker.pagination.prev();
		this.loadData();
	}

	next() {
		this.chunker.pagination.next();
		this.loadData();
	}

	goToPage(p) {
		// console.log('goToPage', p, this.chunker.pagination);
		this.chunker.pagination.goToPage(p);
		this.loadData();
	}
}

export class UITableComponentOptions {
	public downloadAsExcel = true;
	public downloadAsExcelHeaders = null;
	public downloadAsExcelRowFormatter = null;
	public noToolbar = false;
	public noEmptyText = false;
	public refreshButton = false;
	public onRefreshContext = null;
	public paginationCountSelector = false;
	public onRefreshFunction = () => {
	}
}

export class UITableComponentHeader extends ChunkerFilter {
	public idFunction = null;
	public class = null;
	public style = '';
}
